export function isTouchOrPen(event: PointerEvent) {
  return event.pointerType !== 'mouse'
}
